import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGasBottle = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 35,
	height: 95,
	viewBox: "0 0 35.0 95.0",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M 10.0 20.0 L 10.0 7.5 A 7.5 7.5 0.0 0 1 25.0 7.5 L 25.0 20.0 Z",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("path", {
		d: "M 0.0 25.0 A 17.5 10.0 0.0 1 1 35.0 25.0 L 35.0 95.0 L 0.0 95.0 Z",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})]
});
export default SvgGasBottle;
